
// available user hooks
// usePlatformUtils - returns platform utils
// usePlatform - returns current platform data
// useUserPlatform - returns user platform data

// available user hooks
// useContextAccount - returns context account data
// useCurrentAccount - returns current account data
// useContextUser - returns context user data
// useCurrentUser - returns current user data

import platforms from '/app/data/platforms.json';

const DEFAULT_PLATFORM = 'bignerve';

const ignoredSubdomains = ['www', 'dev', 'staging', 'release'];

const resolvePlatformSlug = (target) => {
	if (ignoredSubdomains.includes(target)) {
		return DEFAULT_PLATFORM;
	}
	
	return target;
}

const resolvePlatform = (target) => {
    return platforms.find(
        platform => platform.subdomain === resolvePlatformSlug(target)
    );
}

const isSubplatformHost = (target) => {
	return !!target && !ignoredSubdomains.includes(target);
};

const isTestHost = (target) => {
	return ignoredSubdomains.includes(target);
};

const fromPlatformResponse = (response) => {
	if (!response?.data) return null;

	return { ...response.data, filters: response.relationships?.filters ?? {} };
};

const hasUserPlatformSlug = (value) => value && (value !== 'platform');

const RESERVED_SLUGS = ['me', 'platform', 'search', 'skeptic', 'rpg', 'welcome', 'unsubscribe', 'discussion-forums', 'forums'];

const userPlatformRules = [
	/challenges\.show/,
	/challenges\.rate/,
	/challenges\.start-rate/,
	/home\.user/,
	/home\.user\.medals/,
	/dashboard\./,
	/account\./,
	({ name, params }) => /home.olympiads/.test(name) && hasUserPlatformSlug(params.platformSlug),
	({ name, params }) => /platform\./.test(name) && hasUserPlatformSlug(params.platformSlug),
	({ name, params }) => /discussion-forums\./.test(name) && hasUserPlatformSlug(params.platformSlug),
	({ name, params }) => /^blog/.test(name) && hasUserPlatformSlug(params.platformSlug),
	({ name, params }) => /home.challenges.search/.test(name) && !!params.platformSlug,
];

export {
    platforms,
    ignoredSubdomains,
    resolvePlatform,
    resolvePlatformSlug,
    DEFAULT_PLATFORM,
    userPlatformRules,
    RESERVED_SLUGS,
    isSubplatformHost,
    isTestHost,
    fromPlatformResponse,
}